export default __webpack_public_path__ + "static/media/direction.b629bd50.png";